@if (optionGroup$) {
  <motn-popover-multi-select
    [multiOrSingle]="multiOrSingle"
    [optionGroup$]="optionGroup$"
    [inputPlaceholder]="'Tile Name or ID'"
    (clickedOutsideMenu$)="clickedOutsideMenu$.emit()"
    (clickedOption$)="onSelectTile($event)"
    [overlayPositions]="overlayPositions"
  ></motn-popover-multi-select>
}
